import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EditWhatsAppSettings = lazy(() =>
  import("@scenes/WhatsAppSettings/components/WhatsAppSettings").then((module) => ({
    default: module.WhatsAppSettings,
  }))
);

export const WhatsAppSettingsNRO: NavigationRoutingObject = {
  section: "settings",
  Component: EditWhatsAppSettings,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("whatsapp-settings-edit-nro-heading", "WhatsApp Settings"),
  pageNameForTracking: () => "WhatsApp Settings",
  tag: "beta",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("whatsapp_creative_optimizations") &&
      hasPermission("appGroup", { permission: "editWhatsappSettings" })
    );
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
};
